import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { PlaceholderConfigItem } from '../services/contract-management.service';
import { applyMask } from '../utils/placeholder-utils';

type PlaceholderInputProps = {
  placeholderKey: string;
  config?: PlaceholderConfigItem | null;
  value: string;
  onChange: (value: string) => void;
  id?: string;
  disabled?: boolean;
  /** Quando true (ex.: campo com fórmula), o input é somente leitura. */
  readOnly?: boolean;
};

export function PlaceholderInput({
  placeholderKey,
  config,
  value,
  onChange,
  id,
  disabled,
  readOnly = false,
}: PlaceholderInputProps) {
  const label = config?.label?.trim() || `\${${placeholderKey}}`;
  const placeholderText = config?.example?.trim() || placeholderKey;
  const type = config?.type || 'text';
  const isReadOnly = readOnly || !!config?.formula?.trim();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isReadOnly) return;
    const raw = e.target.value;
    if (type === 'number') {
      const digits = raw.replace(/\D/g, '');
      onChange(digits);
      return;
    }
    if (type === 'currency') {
      const masked = applyMask('currency', raw);
      onChange(masked);
      return;
    }
    const masked = applyMask(type, raw);
    onChange(masked);
  };

  const inputType =
    type === 'email'
      ? 'email'
      : type === 'number' || type === 'currency'
        ? 'text'
        : type === 'date'
          ? 'text'
          : 'text';

  const inputMode = type === 'number' ? 'numeric' : type === 'currency' ? 'decimal' : undefined;

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-xs text-muted-foreground">
        {label}
      </Label>
      <Input
        id={id}
        type={inputType}
        value={value}
        onChange={handleChange}
        placeholder={placeholderText}
        disabled={disabled}
        readOnly={isReadOnly}
        inputMode={isReadOnly ? undefined : inputMode}
      />
    </div>
  );
}
